import { Injectable } from "@angular/core";
import { catchError, Observable, throwError } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Utils } from "src/app/utils/utils";

@Injectable({providedIn: "root"})
export class KpiProductHierarchyService  {

    private readonly API_KPIPRODUCTHIERARCHY = 'api/kpiproducthierarchy';

    constructor(private readonly http: HttpClient) {}

    getAllKpiProductsHierarchy(): Observable<KpiProductHierarchy[]> {
        return this.http.get<KpiProductHierarchy[]>(environment.endpoint + this.API_KPIPRODUCTHIERARCHY).pipe(
            catchError(error => {
                Utils.writeLog(this.http, environment.endpoint + this.API_KPIPRODUCTHIERARCHY, error);
                return throwError(() => error);
            })
        );
    }
    
    getLinesOfBusinessKpiProductHierarchy(): Observable<KpiBreakdown[]> {
        return this.http.get<KpiBreakdown[]>(environment.endpoint + this.API_KPIPRODUCTHIERARCHY + '/linesOfBusiness').pipe(
            catchError(error => {
                Utils.writeLog(this.http, environment.endpoint + this.API_KPIPRODUCTHIERARCHY, error);
                return throwError(() => error);
            })
        );
    }

    getAssetTypesKpiProductHierarchy(): Observable<KpiBreakdown[]> {
        return this.http.get<KpiBreakdown[]>(environment.endpoint + this.API_KPIPRODUCTHIERARCHY + '/assetType').pipe(
            catchError(error => {
                Utils.writeLog(this.http, environment.endpoint + this.API_KPIPRODUCTHIERARCHY + '/assetType', error);
                return throwError(() => error);
            })
        );
    }

    getIsAvailableProductId(productId: string): Observable<any> {
        return this.http.get<any>(environment.endpoint + this.API_KPIPRODUCTHIERARCHY + '/isAvailable/' + productId).pipe(
            catchError(error => {
                Utils.writeLog(this.http, environment.endpoint + this.API_KPIPRODUCTHIERARCHY + '/isAvailable/' + productId, error);
                return throwError(() => error);
            })
        );
    }

    getProductHistory(productId: string): Observable<KpiProductHierarchyHistory[]> {
        return this.http.get<KpiProductHierarchyHistory[]>(environment.endpoint + this.API_KPIPRODUCTHIERARCHY + "/history/" + productId).pipe(
            catchError(error => {
                Utils.writeLog(this.http, environment.endpoint + this.API_KPIPRODUCTHIERARCHY + "/history/" + productId, error);
                return throwError(() => error);
            })
        );
    }

    updateProduct(body: any): Observable<any> {
        return this.http.put<any>(environment.endpoint + this.API_KPIPRODUCTHIERARCHY + '/update', body).pipe(
            catchError(error => {
                Utils.writeLog(this.http, environment.endpoint + this.API_KPIPRODUCTHIERARCHY + '/update', error);
                return throwError(() => error);
            })
        );
    }

}